var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt79 pl481 text-center pb100"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"color3 fs46 mb58 fw-600"},[_vm._v(_vm._s(_vm.info.skillName))]),_c('div',{staticClass:"w-max text-left mt50 fs18 ql-editor",domProps:{"innerHTML":_vm._s(_vm.info.skillCont)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }